import { BarsArrowUpIcon, ChevronDownIcon, MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import Button from '@/components/UI/Button';
import type { PermissionCommons } from '../../types/Permission';
import { HasPermission } from '../Permission/HasPermission';

export interface SectionHeadingProps {
  title: string;
  titleStyle?: string;
  sortBtn?: boolean;
  filterBtn?: boolean;
  includeSearchBar?: boolean;
  customButton?: React.ReactNode;
  buttonConfig?: {
    label?: string;
    permission?: Partial<PermissionCommons>;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
  };
  // ! Deprecated
  // ? use buttonConfig instead
  buttonClickHandler?: () => void;
  btnText?: string;
  includePrimaryBtn?: boolean;
}
export default function SectionHeading({
  title,
  titleStyle,
  buttonClickHandler,
  btnText,
  sortBtn,
  filterBtn,
  includePrimaryBtn,
  includeSearchBar,
  customButton,
  buttonConfig,
}: SectionHeadingProps) {
  const { onClick, label, permission } = buttonConfig || {
    permission: {},
  };
  const primaryButton = (
    <div>
      <Button label={label || btnText || ''} btnStyle='btn-primary' onClick={onClick || buttonClickHandler} />
    </div>
  );
  return (
    <div className='my-4 flex items-center justify-between w-full'>
      <h3 className={`${titleStyle ? titleStyle : 'text-xl font-bold m-0'}`}>{title}</h3>
      <div className='mt-3 sm:mt-0 sm:ml-5 px-5 lg:px-5'>
        <label htmlFor='mobile-search' className='sr-only'>
          Search
        </label>
        <label htmlFor='desktop-search' className='sr-only'>
          Search
        </label>
        <div className='flex rounded-md shadow-sm items-center'>
          {includeSearchBar && (
            <div className='relative flex-grow focus-within:z-10 h-full items-center'>
              <div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
                <MagnifyingGlassIcon className='h-5 w-5 text-gray-400' aria-hidden='true' />
              </div>
              <input
                type='text'
                name='mobile-search-users'
                id='mobile-search-users'
                className={`py-2 focus:ring-primaryColor-normal focus:border-primaryColor-normal block w-full rounded-none pl-10 sm:hidden border-gray-300 ${
                  sortBtn ? 'rounded-l-md' : 'rounded-md'
                } `}
                placeholder='Search'
              />
              <input
                type='text'
                name='desktop-search-users'
                id='desktop-search-users'
                className={`py-2 hidden focus:ring-primaryColor-normal focus:border-primaryColor-normal w-full rounded-none rounded-l-md pl-10 sm:block sm:text-sm border-gray-300 ${
                  sortBtn ? 'rounded-l-md' : 'rounded-md'
                }`}
                placeholder={`Search ${title.toLowerCase()}`}
              />
            </div>
          )}
          {sortBtn && (
            <button
              type='button'
              className='-ml-px mr-5 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-hidden focus:ring-1 focus:ring-primaryColor-normal focus:border-primaryColor-normal'
            >
              <BarsArrowUpIcon className='h-5 w-5 text-gray-400' aria-hidden='true' />
              <span className='ml-2'>Sort</span>
              <ChevronDownIcon className='ml-2.5 -mr-1.5 h-5 w-5 text-gray-400' aria-hidden='true' />
            </button>
          )}
          {filterBtn && <Button label='Apply Filter' btnStyle='btn-neutral' />}

          {includePrimaryBtn && !buttonConfig && primaryButton}
          {buttonConfig?.permission ? (
            <HasPermission of={permission?.of}>{primaryButton}</HasPermission>
          ) : label ? (
            primaryButton
          ) : undefined}
          {customButton}
        </div>
      </div>
    </div>
  );
}
